import { useState, useEffect, useCallback } from 'react';
import ViewClinics from '../components/ViewClinics';
import RegisterClinic from '../components/RegisterClinic';
import Modal from '../components/Modal';
import { fetchClinic } from '../utils/apiCalls';
import { useAuth } from '../utils/AuthContext';

export default function Clinics() {
    const { user, token } = useAuth();
    const [clinics, setClinics] = useState([]);
    const [showAddClinicModal, setShowAddClinicModal] = useState(false);
    // Keep selection when navigating away from page
    const [showInactive, setShowInactive] = useState(() => {
        const saved = localStorage.getItem('showInactiveClinics');
        return saved === 'true';
    });

    useEffect(() => {
        localStorage.setItem('showInactiveClinics', showInactive);
    }, [showInactive])

    const loadClinics = useCallback(async () => {
        if (!user || !token) return;
        await fetchClinic(user, token, setClinics, showInactive);
    }, [user, token, showInactive]);

    useEffect(() => {
        loadClinics();
    }, [loadClinics]);

    return (
        <div className='min-h-screen bg-gray-50 p-6'>
            <div className="flex flex-col items-center">
                <h1 className="text-3xl font-bold text-gray-800 mb-8">
                    Clinic Management
                </h1>
            </div>
            <div className='flex justify-end mx-5'>
                <button onClick={() => setShowAddClinicModal(true)} className="inline-flex items-center gap-2 rounded-md bg-green-300 px-4 py-2 text-gray-700 text-sm font-semibold shadow hover:bg-green-400 transition" >
                    + New Clinic
                </button>
            </div>

            <ViewClinics clinics={clinics} showInactive={showInactive} setShowInactive={setShowInactive} />

            {showAddClinicModal && (
                <Modal>
                    <button
                        onClick={() => setShowAddClinicModal(false)}
                        className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 text-lg font-bold"
                    >
                        ✕
                    </button>
                    <RegisterClinic onSuccess={async () => { await loadClinics(); setShowAddClinicModal(false) }}/>
                </Modal>
            )}


            <button onClick={() => window.history.back()} className="mt-10 rounded-lg border border-gray-300 px-6 py-2 text-sm text-gray-600 transition hover:bg-docpgrPurple10 hover:text-gray-800 hover:scale-105">
                Back
            </button>

        </div>
    )
}